import { createFileRoute } from "@tanstack/react-router";
import { RuntimeDetail } from "../../features/training/environments";

export const Route = createFileRoute("/_authed/$org/$project/trainingruntimes/$name")({
  validateSearch: (s: Record<string, unknown>) => ({ source: s.source === "catalog" ? "catalog" : undefined }),
  component: RuntimePage,
});

function RuntimePage() {
  const { org, project, name } = Route.useParams();
  const { source } = Route.useSearch();
  return <RuntimeDetail scope={{ org, project }} name={name} source={source} />;
}
